/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { AddressLine, constructStreetValue, FullAddress } from "../../../services/als";
import { AccountAddress } from "../../azure-b2c/storage";

export interface CreateDeliveryInfoProps {
  selectedAddressLine: AddressLine | undefined;
  selectedFullAddress: FullAddress | undefined;

  addressName: string | undefined;
  addressShort: string | undefined;
  selectedKnownAddress: AccountAddress | undefined;
}

export const createDeliveryInfo = ({
  selectedAddressLine,
  selectedFullAddress,
  selectedKnownAddress,
  addressName,
  addressShort,
}: CreateDeliveryInfoProps) => {
  let deliveryInfo = {};
  if (selectedAddressLine && selectedFullAddress) {
    deliveryInfo = {
      addressName: addressName,
      city: selectedFullAddress.TownCity,
      streetAddress: constructStreetValue(selectedFullAddress),
      postCode: selectedFullAddress.Postcode,
      address: addressShort,
      isNewAddress: true,
    };
  } else if (selectedKnownAddress) {
    deliveryInfo = {
      addressName: selectedKnownAddress.name,
      city: selectedKnownAddress.city,
      streetAddress: selectedKnownAddress.street,
      postCode: selectedKnownAddress.zipCode,
      address: selectedKnownAddress.fullAddress,
      recordId: selectedKnownAddress.recordId,
      isNewAddress: false,
    };
  }

  return deliveryInfo;
};
